var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockKey = function SvgLockKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.772a3.5 3.5 0 0 0-1 6.854v2.146a1 1 0 0 0 2 0v-2.146a3.5 3.5 0 0 0-1-6.854Zm0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm10-9h-4v-3a6 6 0 1 0-12 0v3H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-14a2 2 0 0 0-2-2Zm-14-3a4 4 0 0 1 8 0v3H8v-3Zm14 19H2v-14h20v14Z",
    fill: "currentColor"
  })));
};
export default SvgLockKey;